import React, { useState } from "react";
import { Button } from "@headlessui/react";
import { FunctionOptions } from "./../../types/FunctionOptions";

export interface IndexFunctionCardProps {

	index: number;
	image: string;
	title: string;
	description: string;
	options: FunctionOptions;
	className?: string;
	last?: boolean;

}

const IndexFunctionCard: React.FC<IndexFunctionCardProps> = (props: IndexFunctionCardProps) => {

	const [selectedButton, setSelectedButton] = useState<string | undefined>(undefined);
	const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);

	const selfService = () => {
		setSelectedButton("Self Service");
		setSelectedOption(props.options.selfService);
	};
	const collaborative = () => {
		setSelectedButton("Collaborative");
		setSelectedOption(props.options.collaborative);
	};
	const turnkey = () => {
		setSelectedButton("Turnkey");
		setSelectedOption(props.options.turnkey);
	};

	return (
		<div id={`indexfunctioncard-root-${props.index}`} className="indexfunctioncard-root flex flex-row-2">
			<div id={`indexfunctioncard-image-container-${props.index}`} className="indexfunctioncard-image-container hidden lg:block min-w-[8.3125rem] min-h-[6.75rem] mr-6">
				<img alt="concept" id={`indexfunctioncard-image-${props.index}`} src={`images/${props.image}`} className="indexfunctioncard-image mr-4 w-[8.3125rem] h-[6.75rem] object-fill" />
			</div>
			<div id={`indexfunctioncard-container-${props.index}`} className={`indexfunctioncard-container ${props.last ? "pb-0" : "pb-10"} pl-6 border-l border-black`}>
				<span id={`indexfunctioncard-ring-${props.index}`} className="indexfunctioncard-ring relative flex items-center justify-center w-4 h-4 bg-black rounded-full -left-8 ring-4 ring-white"></span>
				<div id={`indexfunctioncard-section-${props.index}`} className="indexfunctioncard-section flex items-start relative -top-7">
					<div id={`indexfunctioncard-content-${props.index}`} className="indexfunctioncard-content flex flex-col space-y-2">
						<h2 id={`indexfunctioncard-heading-${props.index}`} className="indexfunctioncard-heading">
							{props.title}
						</h2>
						<p id={`indexfunctioncard-description-${props.index}`} className="indexfunctioncard-description">
							{props.description}
						</p>
						<p id={`indexfunctioncard-options-${props.index}`} className="indexfunctioncard-options pt-2 pb-1">
							Combined Platforms provides 3 options:
						</p>
						<div id={`indexfunctioncard-buttons-${props.index}`} className="indexfunctioncard-buttons flex space-x-2">
							<Button id={`indexfunctioncard-self-service-${props.index}`} data-testid={`indexfunctioncard-self-service-${props.index}`} className={`indexfunctioncard-self-service rounded-md px-4 py-2 ${selectedButton === "Self Service" ? "border-[0.1875rem]" : ""}`} onClick={selfService}>
								Self Service
							</Button>
							<Button id={`indexfunctioncard-collaborative-${props.index}`} data-testid={`indexfunctioncard-collaborative-${props.index}`} className={`indexfunctioncard-collaborative rounded-md px-4 py-2 ${selectedButton === "Collaborative" ? "border-[0.1875rem]" : ""}`} onClick={collaborative}>
								Collaborative
							</Button>
							<Button id={`indexfunctioncard-turnkey-${props.index}`} data-testid={`indexfunctioncard-turnkey-${props.index}`} className={`indexfunctioncard-turnkey rounded-md px-4 py-2 ${selectedButton === "Turnkey" ? "border-[0.1875rem]" : ""}`} onClick={turnkey}>
								Turnkey
							</Button>
						</div>
						<div id={`indexfunctioncard-option-${props.index}`} className={`indexfunctioncard-option rounded-md p-4 flex w-1/2 space-x-2 ${!selectedOption ? "hidden" : ""}`}>
							{selectedOption}
						</div>
					</div>
				</div>
			</div>
		</div>
	);

};

export default IndexFunctionCard;